import './Button.css'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    text: string
    onPress: () => void
    buttonColor?: string
    textColor?: string
}

export const Button = ({text, onPress, buttonColor, textColor, ...rest} : ButtonProps) => {
    return (
        <button
            className="common-button"
            {...rest}
            style={Object.assign({backgroundColor: buttonColor ?? 'var(--primary)'}, rest.style)}
            onClick={onPress}
        >
            <span style={{color: textColor ?? 'var(--fixedWhite)'}}>{text}</span>
        </button>
    )
}
